<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { onMount } from 'svelte';
  import {
    AppState,
    SetIconsBackground,
    SetNotification
  } from '../../../etc/stores';
  import CouponExpiredIcon from '../../icons/CouponExpiredIcon.svelte';
  import MessagePopup from '../../misc/MessagePopup.svelte';
  import ThemedIcon from '../../misc/ThemedIcon.svelte';
  import Button from '../../form/Button.svelte';
  import Link from '../../misc/Link.svelte';
  import Close from '../../icons/Close.svelte';
  import Analytics from '../../../services/analytics';
  import PoweredBy from '../../misc/PoweredBy.svelte';
  import { replaceVariables } from '../../../i18n';
  import Heading from '../../typography/Heading.svelte';
  import Text from '../../typography/Text.svelte';

  const t = (text: string, values: any = {}) => {
    return replaceVariables($_(`welcome_coin_expired_popup.${text}`), values);
  };

  const closeMessage = () => {
    SetNotification('');
  };

  const goToWallet = () => {
    AppState.update(state => ({
      ...state,
      website: {
        ...state.website,
        popoverOpen: true,
        popoverRouteOnOpen: {
          route: '/dashboard'
        }
      }
    }));

    closeMessage();
  };

  const continueBrowsing = () => {
    closeMessage();
  };

  onMount(() => {
    SetIconsBackground('light-without-background');
    Analytics.logEvent('claim-error-campaign-expired', 'free-coins-state');
  });
</script>

<MessagePopup>
  <div class="welcome-coin-expired--wrapper">
    <div class="welcome-coin-expired--close" on:click={closeMessage}>
      <ThemedIcon>
        <Close />
      </ThemedIcon>
    </div>
    <CouponExpiredIcon />
    <div class="welcome-coin-expired--content">
      <Heading type="h2" textAlign="center">
        {@html t('title')}
      </Heading>
      <Text type="default" textAlign="center">
        {t('description', { firstName: $AppState.customer.name })}
      </Text>
    </div>
    <Button label={t('btn')} on:click={continueBrowsing} />
    <div class="welcome-coin-expired--link">
      <Link fontSize="14px" lineHeight="20px" on:click={goToWallet}>
        {t('link')}
      </Link>
    </div>
    <PoweredBy />
  </div>
</MessagePopup>

<style lang="scss">
  @use './styles.scss' as *;

  .welcome-coin-expired {
    &--wrapper {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      width: 100%;
      padding: 24px 16px 0;
      box-sizing: border-box;
    }

    &--content {
      :global(h2) {
        margin-top: 16px !important;
      }

      :global(p) {
        margin-top: 16px !important;
        margin-bottom: 24px !important;
      }
    }

    &--link {
      margin: 24px 0;
    }

    &--close {
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
    }
  }
</style>
